export const MY_AUDIENCES_TYPES = {
    FIRST_PARTY: 'FIRST_PARTY',
    CUSTOM_AUDIENCE: 'CUSTOM_AUDIENCE',
    PIXEL_LOOKALIKE: 'PIXEL_LOOKALIKE',
    CRM_LOOKALIKE: 'CRM_LOOKALIKE',
    PIXEL_BASED_PREDICTIVE: 'PIXEL_BASED_PREDICTIVE',
};
